import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import useGlobalSearchVerticalTabHotels from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabHotels'
import { SEARCH_VERTICAL_ITEMS } from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabsV2'
import { SEARCH_VERTICALS } from 'constants/search'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import GlobalSearchState, { GlobalSearchAction, GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { SUPPORTED_DESTINATION_IDS, SupportedDestinations } from 'home/constants'
import { capitalise } from 'lib/string/stringUtils'
import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

function MobileSearch({ match }: RouteComponentProps<{ destination: SupportedDestinations}>) {
  const globalSearchVerticalTabHotels = useGlobalSearchVerticalTabHotels(SEARCH_VERTICAL_ITEMS.get(SEARCH_VERTICALS.HOTELS))
  const { context, ContentComponent: SearchElement, onSearch } = globalSearchVerticalTabHotels

  const { destination } = match.params
  const destinationId = SUPPORTED_DESTINATION_IDS[destination]

  // sync search item
  useEffect(() => {
    const searchItem: App.SearchItem = {
      searchType: 'destination',
      value: destinationId,
      format: {
        mainText: capitalise(destination),
      },
    };
    (context.dispatch as React.Dispatch<GlobalSearchAction>)({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem })
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [])

  return (
    <GlobalSearchContextProvider state={context.state as GlobalSearchState} dispatch={context.dispatch as React.Dispatch<GlobalSearchAction>}>
      <VerticalSpacer gap={12}>
        <SearchElement
          onSearch={onSearch}
          isInPage
        />
        <TextButton
          kind="primary"
          size="large"
          shape="square"
          fit="full-width"
          onClick={onSearch}
        >
          Search
        </TextButton>
      </VerticalSpacer>
    </GlobalSearchContextProvider>
  )
}

export default withRouter(MobileSearch)
